const initialState = {
  workbinProducerCodes: [],
};

const workbinProducerCodesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_WORKBIN_CODES":
      return {
        ...state,
        workbinProducerCodes: action.payload,
      };
    default:
      return state;
  }
};

export default workbinProducerCodesReducer;
